
<div class="container">
    <div class="row mb-3 mt-2">
        <!-- totali-->
        <div class="container">
            <label class="mr-2 pt-2">{{'grafico.anno_selezionato' | translate}}</label>
            <select  class="form-control-sm" [(ngModel)]="anniGrafici!.anno_selezionato" (ngModelChange)="annoTotaleChange($event)">
                    <option *ngFor="let item of anniGrafici!.anni_disponibili" >{{item}}</option>
            </select>
        </div>
        <div class="col-12 col-xl-6 py-2" *ngIf="graficoTotali!=undefined">  
            <div class="content" *ngIf="anniGrafici!.anni_disponibili.length >0 ">
                <h3 class="titleContainer font-weight-bold h4 d-inline">{{'grafico.fatturato' | translate}}</h3>
                <ul class="nav nav-tabs float-end" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link grafici" id="active-tab"  [ngClass]="totaliMode=='ANNO'?'active':''"  type="button" role="tab" 
                            (click)="setTotaliMode('ANNO')" >{{'grafico.mese' | translate}}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link grafici"  [ngClass]="totaliMode=='TRIMESTRE'?'active':''"  type="button" role="tab" 
                        (click)="setTotaliMode('TRIMESTRE')">{{'grafico.trimestre' | translate}}</button>
                    </li>
                </ul>
            </div>
            <div *ngIf="!graficoTotaliLoader; else waitingTotali" >
                <canvas baseChart
                    [datasets]="graficoTotali.dati" 
                    [labels]="graficoTotali.labels"
                    [options]="graficoTotali.options"
                    [legend]="graficoTotali.legend"
                    [chartType]="graficoTotali.type"
                    [plugins]="barChartPlugins">
                </canvas>
                
                <div class="col">
                    <p><span class="font-weight-bold">{{'grafico.totale_fatturato_attivo' | translate}}: {{graficoTotali.totale_positivo}} €</span><br>
                    <span class="font-weight-bold">{{'grafico.totale_fatturato_passivo' | translate}}: {{graficoTotali.totale_negativo}} €</span></p>
                </div>
                
            </div>
            <ng-template #waitingTotali>
                <app-loading></app-loading>
            </ng-template>
        </div>
        <!--iva-->
        <div class="col-12 col-xl-6 py-2" *ngIf="graficoIva!=undefined"> 
            <div class="content" >
                <h3 class="titleContainer font-weight-bold h4 d-inline">Saldo netto</h3>
                <ul class="nav nav-tabs float-end" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button class="nav-link grafici" [ngClass]="ivaMode=='ANNO'?'active':''" type="button" role="tab" 
                                (click)="setIvaMode('ANNO')">{{'grafico.mese' | translate}}</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link grafici" [ngClass]="ivaMode=='TRIMESTRE'?'active':''" type="button" role="tab" 
                                (click)="setIvaMode('TRIMESTRE')">{{'grafico.trimestre' | translate}}</button>
                    </li>
                </ul>
            </div>
            <div *ngIf="!graficoIvaLoader; else waitingIva">
                <canvas baseChart *ngIf="ivaMode=='ANNO' || (ivaViewMode=='GRAFICO' && ivaMode=='TRIMESTRE')"
                    [datasets]="graficoIva.dati" 
                    [labels]="graficoIva.labels"
                    [options]="graficoIva.options"
                    [legend]="graficoIva.legend"
                    [chartType]="graficoIva.type"
                    [plugins]="barChartPlugins">
                </canvas>
                <table class="table  bg-white" *ngIf="ivaViewMode=='TABELLA' && ivaMode=='TRIMESTRE'">
                    <thead>
                        <tr>
                            <th class="col">{{'grafico.trimestre' | translate}}</th>
                            <th class="col">{{'grafico.iva_a_credito' | translate}}</th>
                            <th class="col">{{'grafico.iva_a_debito' | translate}}</th>
                            <th class="col">{{'grafico.saldo_iva' | translate}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let trimestre of graficoIva.dati[0].data; index as i">
                            <td>{{graficoIva.labels[i]}}</td>
                            <td>+ {{trimestre}} €</td>
                            <td>- {{graficoIva.dati[1].data[i]}} €</td>
                            <td [ngClass]="comparaValoriNumerici(trimestre, graficoIva.dati[1].data[i]) ? 'text-success': (trimestre == graficoIva.dati[1].data[i] ?'':'text-danger')" class="font-weight-bold">
                                {{ trimestre > graficoIva.dati[1].data[i]?'+':'' }} {{ (trimestre - graficoIva.dati[1].data[i]).toFixed(2)  }} €</td>
                        </tr>
                    </tbody>
                </table>
                <div class="row">
                <div class="col-auto">
                        <p>
                            <span class="font-weight-bold">{{'grafico.totale_iva_credito' | translate}}: {{graficoIva.totale_positivo}} €</span>
                            <br>
                            <span class="font-weight-bold">{{'grafico.totale_iva_debito' | translate}}: {{graficoIva.totale_negativo}} €</span>
                            <br>
                        </p>
                </div>
                <div class="col text-end" *ngIf="ivaMode!='ANNO'">
                        <button class="btn btn-sm btn-primary" (click)="cambiaVistaIva()">{{ ivaViewMode=='TABELLA'? 'Vedi grafico': 'Vedi Tabella' }}</button>
                </div>
                </div>
            </div>
            
                
            

            <ng-template #waitingIva>
                <app-loading></app-loading>
            </ng-template>
        </div>
    </div>
</div>